<template>
  <div>
    <DefaultServiceValuesListFilters />

    <DefaultServiceValuesTabs />

    <v-card outlined>
      <DefaultServiceValuesTabsList />
    </v-card>

    <h-pagination :fetch="fetchDefaultServiceValues" />

    <InactivateDefaultServiceValuesModal />

    <DefaultServiceValuesCreate ref="createDefaultServiceValues" />
  </div>
</template>

<script>
import DefaultServiceValuesCreate from '@/components/defaultServiceValues/DefaultServiceValuesCreate'
import DefaultServiceValuesTabs from '@/components/defaultServiceValues/tabs/DefaultServiceValuesTabs'
import DefaultServiceValuesTabsList from '@/components/defaultServiceValues/tabs/DefaultServiceValuesTabsList'
import DefaultServiceValuesListFilters from '@/components/defaultServiceValues/DefaultServiceValuesListFilters'
import InactivateDefaultServiceValuesModal from '@/components/defaultServiceValues/modals/InactivateDefaultServiceValuesModal'

import { mapActions } from 'vuex'

export default {
  name: 'DefaultServiceValuesList',

  components: {
    DefaultServiceValuesCreate,
    DefaultServiceValuesTabs,
    DefaultServiceValuesTabsList,
    DefaultServiceValuesListFilters,
    InactivateDefaultServiceValuesModal,
  },

  methods: {
    ...mapActions(['fetchDefaultServiceValues', 'fetchServiceTypes']),
  },

  mounted() {
    this.fetchServiceTypes()
  },
}
</script>
